import { Component, input } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import {
  ItemProfileDisplayComponent,
  LinkComponent,
  TitleComponent,
  UserLogoComponent,
  UserLogoData,
} from '@camelot/ui';
import { CamBaseComponent, fullName } from '@camelot/utils';

import { User } from '../../../services/dto/user';
import { CamTranslationUser } from '../../../translation.service';

@Component({
  selector: 'cam-user-profile',
  imports: [ItemProfileDisplayComponent, LinkComponent, TitleComponent, TranslatePipe, UserLogoComponent],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
})
export class UserProfileComponent extends CamBaseComponent {
  user = input.required<Partial<User>>();

  titleKey = input('user.user-profile.title');

  public readonly fullName = fullName;

  constructor() {
    super();
    CamTranslationUser.getInstance();
  }

  public getUserLogoData(user: Partial<User>): UserLogoData {
    return {
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
      trigram: user.trigram,
      picture: user.picture,
    };
  }
}
